/** Only local catalog fabrics are resized; full photos remain available for deliberate zoom. */
export const FABRIC_THUMBNAIL_WIDTHS = [64, 128, 320] as const;
export type FabricThumbnailWidth = typeof FABRIC_THUMBNAIL_WIDTHS[number];
export function fabricThumbnailUrl(src: string, width: FabricThumbnailWidth = 128): string {
  if (!/^\/uploads\/fabrics?\//.test(src)) return src;
  return `/api/images/fabric-thumbnail?src=${encodeURIComponent(src)}&w=${width}`;
}
export function validFabricThumbnailPath(src: string): boolean {
  return /^\/uploads\/fabrics?\/[a-zA-Z0-9_ /().-]+\.(?:jpe?g|png|webp|avif)$/i.test(src) &&
    !src.split('/').some(part => part === '..' || part === '.') && !src.includes('\\');
}
